const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Bugglie performance enhancements (safe, additive) - added 26 Jul via MCP on WORKING COPY */
(function () {
  function enhance() {
    try {
      var imgs = document.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        if (i < 2) continue;
        if (!imgs[i].getAttribute('loading')) imgs[i].setAttribute('loading', 'lazy');
        if (!imgs[i].getAttribute('decoding')) imgs[i].setAttribute('decoding', 'async');
      }
      var vids = document.querySelectorAll('video');
      if (vids.length) {
        for (var j = 0; j < vids.length; j++) {
          var v = vids[j];
          try {
            v.preload = 'none';
            v.setAttribute('playsinline', '');
            v.muted = true;
            if (v.autoplay) { v.autoplay = false; v.setAttribute('data-b-autoplay', '1'); }
            v.pause();
          } catch (e) {}
        }
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            for (var k = 0; k < entries.length; k++) {
              var el = entries[k].target;
              if (entries[k].isIntersecting) {
                try { el.preload = 'auto'; if (el.getAttribute('data-b-autoplay')) { var p = el.play(); if (p && p.catch) p.catch(function () {}); } } catch (e) {}
              } else {
                try { if (el.getAttribute('data-b-autoplay')) el.pause(); } catch (e) {}
              }
            }
          }, { rootMargin: '200px 0px' });
          for (var m = 0; m < vids.length; m++) io.observe(vids[m]);
        }
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', enhance); } else { enhance(); }
})();

/* Bugglie sticky mobile buy-bar (safe, additive) - added 26 Jul via MCP; scrolls to purchase options 27 Jul; refill CTA selector 27 Jul */
(function () {
  if (location.pathname.indexOf('/products/') !== 0) return;
  
  // Disable legacy sticky CTA for the Starter Kit product page using its exact live handle
  if (location.pathname.indexOf('bugglie-quarterly-pest-control-kit') > -1) return;

  function injectStyle() {
    if (document.getElementById('b-sticky-style')) return;
    var s = document.createElement('style');
    s.id = 'b-sticky-style';
    s.textContent = '#b-sticky-buybar{position:fixed;left:0;right:0;bottom:0;z-index:9998;transform:translateY(110%);transition:transform .25s ease;background:#0B0B0C;box-shadow:0 -4px 20px rgba(0,0,0,.35);padding:10px 14px;padding-bottom:calc(10px + env(safe-area-inset-bottom));display:none}#b-sticky-buybar.b-visible{transform:translateY(0)}#b-sticky-buybar .b-sticky-inner{display:flex;align-items:center;gap:12px;max-width:600px;margin:0 auto}#b-sticky-buybar .b-sticky-title{color:#fff;font-weight:600;font-size:14px;flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#b-sticky-buybar .b-sticky-btn{flex:0 0 auto;background:#3594E7;color:#fff;border:0;border-radius:10px;padding:12px 18px;font-weight:700;font-size:15px;cursor:pointer;white-space:nowrap}#b-sticky-buybar .b-sticky-btn:active{opacity:.85}@media(max-width:749px){#b-sticky-buybar{display:block}}';
    document.head.appendChild(s);
  }
  function initBar() {
    try {
      var forms = document.querySelectorAll('form');
      var form = null;
      for (var fi = 0; fi < forms.length; fi++) { var act = forms[fi].getAttribute('action') || ''; if (act.indexOf('/cart/add') > -1) { form = forms[fi]; break; } }
      if (!form) return;
      var cta = form.querySelector('button[type=submit]') || form.querySelector('[type=submit]') || form.querySelector('button[name=add]') || form.querySelector('.primary-cta-btn') || form.querySelector('button');
      if (!cta) return;
      if (document.getElementById('b-sticky-buybar')) return;
      var titleEl = document.querySelector('h1');
      var title = titleEl ? titleEl.textContent.trim() : 'Bugglie';
      if (title.length > 28) title = title.slice(0, 26) + '...';
      var bar = document.createElement('div');
      bar.id = 'b-sticky-buybar';
      var inner = document.createElement('div');
      inner.className = 'b-sticky-inner';
      var titleSpan = document.createElement('span');
      titleSpan.className = 'b-sticky-title';
      titleSpan.textContent = title;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'b-sticky-btn';
      btn.textContent = (cta.textContent || 'Choose your plan').replace(/\s*[-–—]\s*\$\d[\d.,]*.*$/, '').trim();
      btn.addEventListener('click', function () {
        try {
          var target = null;
          var nodes = document.querySelectorAll('h1,h2,h3,h4,h5,h6,p,span,div,strong,label');
          for (var qi = 0; qi < nodes.length; qi++) { var nel = nodes[qi]; var tx = (nel.textContent || '').trim(); if (tx.length < 45 && /choose your (purchase|plan)/i.test(tx)) { target = nel; break; } }
          if (!target) target = form || cta;
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          setTimeout(function () { try { window.scrollBy({ top: -90, behavior: 'smooth' }); } catch (e) {} }, 350);
        } catch (e) {}
      });
      inner.appendChild(titleSpan);
      inner.appendChild(btn);
      bar.appendChild(inner);
      document.body.appendChild(bar);
      try {
        var mo = new MutationObserver(function () { btn.textContent = (cta.textContent || 'Choose your plan').replace(/\s*[-–—]\s*\$\d[\d.,]*.*$/, '').trim(); });
        mo.observe(cta, { childList: true, subtree: true, characterData: true });
      } catch (e) {}
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { bar.classList.toggle('b-visible', !en[0].isIntersecting); }, { threshold: 0 });
        io.observe(cta);
      } else {
        bar.classList.add('b-visible');
      }
    } catch (e) {}
  }
  function go() { injectStyle(); initBar(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', go); } else { go(); }
})();
